import { styled } from '@styles'

export const Container = styled.textarea`
  resize: none;
`
